export default __webpack_public_path__ + "static/media/textalign-right.968f930c.svg";